import { css } from '@linaria/core';

export const button = css`
  --oc-best-odds-width: 65;
  --oc-best-odds-height: 40;

  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 33px;
  height: calc(var(--oc-best-odds-height) * 1px);
  width: calc(var(--oc-best-odds-width) * 1px);
  max-width: 100%;
  margin: 0;
  background: #f2f5f6;
  border: none;
  border-radius: 4px;
  font-family: var(--oc-font-family);
  font-size: 15px;
  text-align: center;
  text-indent: 0;
  color: var(--oc-text-body);
  transition: background-color 1s ease-out;
  cursor: pointer;
  transform: translateY(-1px);
  font-weight: 700;
  line-height: 24px;
  overflow: hidden;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    background: var(--oc-neutral-4); /* Example disabled background */
    color: var(--oc-text-muted);
    transform: none;
  }

  &:hover {
    background: #66f1b8;
  }
`;

export const buttonWithBadge = css`
  --oc-best-odds-width: 100;
`;

export const drifter = css`
  background-color: var(--oc-odds-drifting-bg);
`;

export const drifterFlash = css`
  background-color: var(--oc-odds-drifting);
`;

export const steamer = css`
  background-color: var(--oc-odds-shortening-bg);
`;

export const steamerFlash = css`
  background-color: var(--oc-odds-shortening);
`;

export const flash = css`
  transition: background-color 1s ease-out;
`;

export const noAnimation = css`
  transition: none !important;
  animation: none !important;

  /* Keep original colors but disable transitions */
  &.${drifter} {
    background-color: var(--oc-odds-drifting-bg) !important;
  }

  &.${steamer} {
    background-color: var(--oc-odds-shortening-bg) !important;
  }

  &.${drifterFlash} {
    background-color: var(--oc-odds-drifting-bg) !important;
  }

  &.${steamerFlash} {
    background-color: var(--oc-odds-shortening-bg) !important;
  }
`;

export const selectedBet = css`
  background-color: var(--ogm-grid-selected-cell-bg-color);
  color: var(--ogm-grid-selected-cell-text-color);
`;

export const bookieLogo = css`
  max-height: 100%;
  border-radius: 4px;
  padding: 2px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden;
`;

export const buttonUnsupported = css`
  background-color: var(--ogm-white);
  border: 1px solid var(--ogm-disabled-grey);
  border-radius: 16px;
  color: var(--ogm-disabled-grey);
  cursor: not-allowed;

  .${bookieLogo} {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
  }
`;

export const textWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 100%;
  width: 100%;
  padding: 4px;
`;

export const ocLogoWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
`;

export const logoWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 32px;
  min-width: 32px;
  overflow: clip;
`;

export const buttonWithVerticalBadge = css`
  --oc-best-odds-width: 65;
  --oc-best-odds-height: 50;
  overflow: hidden;

  &.${button} {
    flex-direction: column;
    padding: 0;
  }

  .${logoWrapper} {
    width: 100%;
    height: auto;
    align-items: flex-start;
  }

  .${bookieLogo} {
    padding: 2px;
    border-radius: 4px;
    margin: 0;
    width: 100%;
    height: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .${textWrapper} {
    padding: 0;
  }
`;
